import styled from 'styled-components';

export const DocContainer = styled.div`
  padding: 25px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 26px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
`;

export const SubTitle = styled.h3`
  color: #34495e;
  margin-top: 25px;
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: 600;
`;

export const Paragraph = styled.p`
  line-height: 1.7;
  margin-bottom: 18px;
  color: #333;
  font-size: 16px;
`;

export const List = styled.ul`
  margin-left: 25px;
  margin-bottom: 20px;
`;

export const ListItem = styled.li`
  margin-bottom: 10px;
  line-height: 1.6;
`;

export const OrderedList = styled.ol`
  margin-left: 25px;
  margin-bottom: 20px;
`;

export const OrderedListItem = styled.li`
  margin-bottom: 10px;
  line-height: 1.6;
`;

export const Code = styled.code`
  background-color: #f5f5f5;
  padding: 2px 5px;
  border-radius: 3px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
`;

export const Link = styled.a`
  color: #1a73e8;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const Note = styled.div`
  background-color: #f8f9fa;
  border-left: 4px solid #4285f4;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
`;

export const Warning = styled.div`
  background-color: #fff3e0;
  border-left: 4px solid #ff9800;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
`;

export const TableHead = styled.thead`
  background-color: #f5f5f5;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

export const TableHeader = styled.th`
  padding: 12px 15px;
  text-align: left;
  border-bottom: 2px solid #ddd;
`;

export const TableCell = styled.td`
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
